module.exports = __webpack_public_path__ + "static/media/clicks.e22186e4.svg";